import { Navigate, useParams } from "react-router";
import { useWeekPlan } from "@/context/week-plan-context";
import { getTodayDayOfWeek } from "@/lib/week-utils";

export function WeekIndexRedirect() {
  const { weekId } = useParams<{ weekId: string }>();
  const { basePath } = useWeekPlan();
  const today = weekId ? getTodayDayOfWeek(weekId) : null;
  return <Navigate to={`${basePath}/${weekId}/${today ?? "mon"}`} replace />;
}
